// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z4zK","right":"styles_right__2a9qg"};